import { MUT_ALTERS } from "./mut-columns.js";

export const labelsTable = `
CREATE TABLE IF NOT EXISTS labels (
  id          TEXT PRIMARY KEY,
  name        TEXT NOT NULL,
  color       TEXT,
  mut         INTEGER NOT NULL DEFAULT 0,
  server_acked_mut INTEGER NOT NULL DEFAULT 0,
  created_at  TEXT NOT NULL,
  updated_at  TEXT NOT NULL,
  deleted_at  TEXT
);
`.trim();

export const labelsAlters = MUT_ALTERS("labels", { google: false });
